<template>
  <div class="col border-white">
    <div class="row">
      <div class="col-1">
        <h3 class="sous-section">Groupe de sécurité</h3>
      </div>
    </div>
    <div class="row"/>
    <div class="row">
      <div class="row">
        <div class="col-2 lbl">
          <label>Groupe de sécurité :</label>
        </div>
        <div class="col-4">
          <Dropdown v-model="groupe"
                    :options="groupeLibelles" optionValue="cle"
                    optionLabel="nom" scrollHeight="205px" :showClear="true"/>
        </div>
      </div>
    </div>
  </div>
  <div class="col border-white">
    <div class="row">
      <div class="col-1">
        <h3 class="sous-section">Rôles</h3>
      </div>
    </div>
    <div class="row"/>
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-2 lbl">
            <label>Application :</label>
          </div>
          <div class="col-4">
            <Dropdown v-model="application"
                      :options="applicationLibelles" optionValue="valeur"
                      optionLabel="texte" scrollHeight="205px" :showClear="true"/>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-2 lbl">
            <label>Écran :</label>
          </div>
          <div class="col-4">
            <Dropdown v-model="ecran"
                      :options="ecranLibelles" optionValue="valeur"
                      optionLabel="texte" scrollHeight="205px" :showClear="true"/>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-2 lbl">
        <label>Groupes :</label>
      </div>
      <div class="col-9">
        <vue-list-picker title-left="Disponibles" title-right="Attribués" min-height="120px" :content-substr=100 class="left"
                         :left-items="leftRolesDisponibles" :right-items="rightRolesAttribues"/>
      </div>
    </div>
    <div class="row"/>
  </div>
  <div class="row"/>
</template>

<script>
import {mapGetters} from 'vuex';
import {VueListPicker} from 'vue-list-picker';
import axios from "axios";

export default {
  name: 'CriteresRechercheRolesGroupe',
  emits: ['fermer'],
  components: {
    VueListPicker
  },
  data() {
    return {
      groupe: null,
      application: null,
      ecranLibelles: [],
      ecran: null,
      groupeLibelles: [],
      listDisponibles: [],
      listAttribues: [],
      leftRolesDisponibles: [],
      rightRolesAttribues: [],

      applicationLibelles: [
        {texte: 'Cardex', valeur: 'cardex'},
        {texte: 'Pilotage', valeur: 'pilotage'},
      ],
    };
  },
    computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
    })
  },
  beforeMount() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$store.dispatch("pilotage/rechercherTableValeurSansAscAction", 'Ecran').then((res) => {
        this.ecranLibelles = res.data.sort(this.$commun.compareLibelles);
      });

    this.$store.dispatch("pilotage/rechercherGroupesSecuriteAction", null).then((res) => {
      this.groupeLibelles = res.data.sort((a, b) => {
        return this.$commun.compareString(a.nom, b.nom)
      });
    });
  },
  methods: {
    getGroupe() {
      return this.groupe;
    },
    getRolesAttribues() {
      let rolesAttribues = [];
      for (let i = 0; i < this.rightRolesAttribues.length; i++) {
        rolesAttribues.push({
          cleGroupeSecurite: this.groupe,
          cleRoleSecurite: this.rightRolesAttribues[i].key,
        })
      }
      return rolesAttribues;
    },
    getRolesDisponibles() {
      if (this.ecran) {
        this.$root.$refs.breadcrumbComp.activeBallBeat = true;
        this.$store.dispatch('pilotage/obtenirEcranRoleSecuriteAction', this.ecran)
            .then((res) => {
              this.listDisponibles = res.data.sort((a, b) => {
                return this.$commun.compareString(a.role, b.role)
              });
              this.listDisponibles = this.listDisponibles.filter(rd => !this.rightRolesAttribues.find(ra => (ra.key === rd.cle)));
              if (this.application != null) {
                this.listDisponibles = this.listDisponibles.filter(rd => rd.application === this.application);
              }
              this.leftRolesDisponibles.splice(0);
              for (let i = 0; i < this.listDisponibles.length; i++) {
                this.leftRolesDisponibles.push({
                  key: this.listDisponibles[i].cle,
                  content: this.listDisponibles[i].role,
                })
              }
              this.$root.$refs.breadcrumbComp.activeBallBeat = false;
            });
      }
    },
  },
  watch: {
    'groupe': function (groupeSecuriteCle) {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      this.$store.dispatch('pilotage/obtenirGroupeSecuriteCleRoleAction', groupeSecuriteCle)
          .then((res) => {
            this.listAttribues = res.data.sort((a, b) => {
              return this.$commun.compareString(a.role, b.role)
            });
            this.rightRolesAttribues.splice(0);
            for (let i = 0; i < this.listAttribues.length; i++) {
              this.rightRolesAttribues.push({
                key: this.listAttribues[i].cle,
                content: this.listAttribues[i].role,
              })
            }
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    },
    'application': function () {
      this.getRolesDisponibles();
    },
    'ecran': function () {
      this.getRolesDisponibles();
    }
  }
}
</script>